import React from "react";
import {
  LayoutGrid,
  PhoneCall,
  Users,
  ClipboardList,
  BarChart3,
  DollarSign,
  UserPlus,
  Trophy,
  Users2,
} from "lucide-react";
import { APP_IDS } from "../constants/testIds";

const ICONS = {
  grid: LayoutGrid,
  renewals: PhoneCall,
  sellers: Users,
  log: ClipboardList,
  report: BarChart3,
  drawings: Trophy,
  checkin: Users2,
  deposit: DollarSign,
  assign: UserPlus,
};

const DEFAULT_TABS = [
  { key: "grid", label: "Ticket Grid", short: "Grid", testId: APP_IDS.tabGrid },
  { key: "sellers", label: "Sellers", short: "Sellers", testId: APP_IDS.tabSellers },
  { key: "log", label: "Activity Log", short: "Log", testId: APP_IDS.tabLog },
  { key: "report", label: "Report", short: "Report", testId: APP_IDS.tabReport },
];

export const TabBar = ({ active, onChange, tabs }) => {
  const list = tabs || DEFAULT_TABS;
  return (
    <div
      data-testid="tab-bar"
      className="fixed bottom-0 sm:bottom-auto left-0 right-0 z-30 sm:static sm:sticky sm:top-0"
      style={{
        background: "var(--surface-card)",
        borderTop: "1px solid var(--border-default)",
        boxShadow: "0 -1px 3px rgba(11,18,20,0.06)",
        paddingBottom: "max(env(safe-area-inset-bottom), 0px)",
      }}
    >
      <div className="max-w-7xl mx-auto px-2 sm:px-6 py-2 sm:py-3">
        <div className="relative">
          <nav
            role="tablist"
            className="flex items-center gap-1 rounded-xl sm:rounded-full p-1 sm:p-1.5 overflow-x-auto no-scrollbar"
            style={{ background: "var(--surface-subtle)" }}
          >
            {list.map((t) => {
              const isActive = active === t.key;
              const Icon = ICONS[t.key];
              return (
                <button
                  key={t.key}
                  id={`tab-button-${t.key}`}
                  role="tab"
                  aria-selected={isActive}
                  aria-controls={`tab-panel-${t.key}`}
                  data-testid={t.testId}
                  onClick={() => onChange(t.key)}
                  className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 sm:gap-2 px-2.5 sm:px-4 py-2 sm:py-2 rounded-lg sm:rounded-full text-xs sm:text-sm font-semibold whitespace-nowrap focus:outline-none"
                  style={{
                    background: isActive ? "var(--surface-card)" : "transparent",
                    color: isActive ? "var(--brand-primary)" : "var(--ink-secondary)",
                    boxShadow: isActive ? "var(--shadow-sm), inset 0 0 0 1px var(--border-default)" : "none",
                    transition:
                      "background-color var(--duration-base) var(--ease-standard), color var(--duration-base) var(--ease-standard), box-shadow var(--duration-base) var(--ease-standard)",
                  }}
                >
                  {Icon && <Icon className="h-4 w-4 shrink-0" strokeWidth={isActive ? 2.4 : 2} />}
                  <span className="hidden sm:inline">{t.label}</span>
                  <span className="sm:hidden">{t.short}</span>
                </button>
              );
            })}
          </nav>
          {/* Right-edge fade hint so users on narrow screens know more tabs are scrollable */}
          <div
            aria-hidden="true"
            className="sm:hidden pointer-events-none absolute top-0 right-0 h-full w-8 rounded-r-xl"
            style={{
              background:
                "linear-gradient(to left, var(--surface-subtle), transparent)",
            }}
          />
        </div>
      </div>
    </div>
  );
};
